import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            关于每日大赛mrds参赛入口和参与方式的常见疑问解答
          </p>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <details
                key={idx}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 pr-4">
                    {item.q}
                  </h3>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-background-100 group-open:bg-primary-100 transition-colors">
                    <i className="ri-arrow-down-s-line text-foreground-600 group-open:text-primary-600 group-open:rotate-180 transition-transform text-sm"></i>
                  </div>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}